import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowDown",
  "use": "arrowDown-usage",
  "viewBox": "0 0 18 22",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 22\" id=\"arrowDown\">\n\t<path d=\"m16.522 11.866 1.318 1.278-7.542 7.507.022.022-1.233 1.198-.007-.007-.002.002-.161-.166L.32 13.068l1.162-1.197 7.55 7.52z\" />\n\t<path d=\"M10 18.986v-19H8v19z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol